define(function (require) {
    var ko = require("knockout");
    var _ = require("underscore");
    var querystring = require("querystring");
    var urlParameters = require("@modules/tools/urlParameters");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var scanTranslations = require("scanTranslations");

    var tierLabel = "Tier";
    scanTranslations.getInstance().then(function (scanTranslationInstance) {
        tierLabel = scanTranslationInstance.translate("tier-label");
    });

    // ctor for FormularyResultViewModel
    return function (parent, data, year) {
        var self = this;

        self.formularyId = ko.observable(data.FormularyId);
        self.therapeuticClass = ko.observable(data.HpmsTherapeuticClass);
        self.therapeuticCategory = ko.observable(data.HpmsTherapeuticCategory);
        self.isGeneric = ko.observable(data.IsGeneric);
        self.tierPref = ko.observable(data.TierPref);
        // self.stepNumber = ko.observable(data.StepNumber);
        // self.dosageForm = ko.observable(data.DosageForm);
        // self.gpi = ko.observable(data.FirstSixGPI);
        // self.priorAuthorization = ko.observable(data.PriorAuthorization);
        // self.priorAuthorizationTypeId = ko.observable(data.PriorAuthorizationTypeID);
        // self.quantityLimit = ko.observable(data.QuantityLimit);
        // self.quantityDays = ko.observable(data.QuantityDays);
        // self.formulary = ko.observable(data.Formulary);
        // self.maintenanceMed = ko.observable(data.MaintenanceMed);
        // self.excludedDrug = ko.observable(data.ExcludedDrug);
        // self.specialtyPharmacy = ko.observable(data.SpecialtyPharmacy);
        // self.combinedQuantityLimit = ko.observable(data.QuantityLimitDescription);

        self.combinedDosage = ko.observable(data.DosageDescription);
        self.trimmedTier = ko.observable(data.TierNumber);
        self.hasQuantityLimit = ko.observable(data.HasQuantityLimit);
        self.hasStepTherapy = ko.observable(data.HasStepTherapy);
        self.hasBvsD = ko.observable(data.HasBvsD);
        self.hasPA = ko.observable(data.HasPA);
        self.hasBvsDandPA = ko.observable(data.HasBvsDandPA);
        self.has90D = ko.observable(data.Has90D);
        self.has100D = ko.observable(data.Has100D);
        self.hasLD = ko.observable(data.HasLD);
        self.hasED = ko.observable(data.HasED);
        self.quantityLimit = ko.observable(data.QuantityLimit);
        self.quantityDays = ko.observable(data.QuantityDays);

        var tierMapper = window.scan.formularyDosageTierMap || {};
        var coverageMapper = window.scan.formularyDosageCoverageLimitMap || {};

        self.viewDetails = function () {
            parent.viewDetails(self.formularyId());
            window.location.href = self.detailUrl();
        };

        self.detailUrl = ko.computed(function () {
            var urlParams = urlParameters.read();
            var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));
            var query = {
                formularyId: self.formularyId(),
                path: path
            };

            if (year) {
                query.formularyyear = year;
            }

            return window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        });

        self.showDrugTier = ko.computed({
            read: function () {
                return "<strong>" + tierLabel + " " + tierMapper[self.trimmedTier()] + "</strong>";
            },
            owner: self
        });

        self.showTheraputicCategoryClass = ko.computed({
            read: function () {
                return self.therapeuticClass() === self.therapeuticCategory() ? self.therapeuticCategory() : self.therapeuticCategory() + "<br/>- " + self.therapeuticClass();
            },
            owner: self
        });

        self.coverageLimitTranslations = ko.computed({
            read: function () {
                var returnList = [];
                // returnList.push("Coverages Don't match Facets");
                if (self.hasED()) {
                    returnList.push(coverageMapper["HasED"]);
                }
                if (self.hasQuantityLimit()) {
                    var qlText = (window.scan.quantityLimitTextFormat || "").replace(/\[\%quantity\%\]/, self.quantityLimit()).replace(/\[\%days\%\]/, self.quantityDays());
                    returnList.push(coverageMapper["HasQuantityLimit"] + " " + qlText);
                }
                if (self.hasStepTherapy()) {
                    returnList.push(coverageMapper["HasStepTherapy"]);
                }
                if (self.hasBvsD()) {
                    returnList.push(coverageMapper["HasBvsD"]);
                }
                if (self.hasPA()) {
                    returnList.push(coverageMapper["HasPA"]);
                }
                if (self.has90D()) {
                    returnList.push(coverageMapper["Has90D"]);
                }
                if (self.has100D()) {
                    returnList.push(coverageMapper["Has100D"]);
                }
                if (self.hasLD()) {
                    returnList.push(coverageMapper["HasLD"]);
                }
                return returnList;
            },
            owner: self
        });

        self.coverageLimitTranslationsLeft = ko.computed({
            read: function () {
                var returnList = [];
                // returnList.push("Coverages Don't match Facets");
                if (self.hasED()) {
                    returnList.push(coverageMapper["HasED"]);
                }
                if (self.hasQuantityLimit()) {
                    var qlText = (window.scan.quantityLimitTextFormat || "").replace(/\[\%quantity\%\]/, self.quantityLimit()).replace(/\[\%days\%\]/, self.quantityDays());
                    returnList.push(coverageMapper["HasQuantityLimit"] + " " + qlText);
                }
                if (self.hasStepTherapy()) {
                    returnList.push(coverageMapper["HasStepTherapy"]);
                }
                if (self.hasBvsDandPA()) {
                    returnList.push(coverageMapper["HasBvsDandPA"]);
                } else {
                    if (self.hasBvsD()) {
                        returnList.push(coverageMapper["HasBvsD"]);
                    }
                    if (self.hasPA()) {
                        returnList.push(coverageMapper["HasPA"]);
                    }
                }
                if (self.hasLD()) {
                    returnList.push(coverageMapper["HasLD"]);
                }
                return returnList;
            },
            owner: self
        });
        self.coverageLimitTranslationsRight = ko.computed({
            read: function () {
                var returnList = [];
                // returnList.push("Coverages Don't match Facets");
                if (self.has90D()) {
                    returnList.push(coverageMapper["Has90D"]);
                }
                if (self.has100D()) {
                    returnList.push(coverageMapper["Has100D"]);
                }
                return returnList;
            },
            owner: self
        });
    };
});
